import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-lab-sidebar",
  templateUrl: "./lab-sidebar.component.html",
  styleUrls: ["./lab-sidebar.component.css"],
})
export class LabSidebarComponent implements OnInit {
  userID: any;
  roleID: any;
  username: any;
  isLab = false;
  env: any;

  constructor() {}

  ngOnInit() {
    this.env = environment;

    this.username = localStorage.getItem("username");
    this.roleID = localStorage.getItem("role_id");
    this.userID = localStorage.getItem("id");
    if (this.roleID == 3 || this.roleID == 4) {
      this.isLab = true;
    }


    

  }


  Mobile_sidebar_menu_btn(){
    $(".mobile-menu-asidebar").fadeToggle(500);
  }

//   if ( $ (window).width() < 992) {

//     Mobile_sidebar_menu_btn(){
//       $(".mobile-menu-asidebar").fadeToggle(500);
//     }

//     alert('Less than 960');
// }


  


}
